import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FuseTableComponent } from '@fuse/components/table/table.component';
import { FilterItemDirective } from '@fuse/directives/filter-item';
import { TableModule } from 'primeng/table';
import { CalendarModule } from 'primeng/calendar';
import { SliderModule } from 'primeng/slider';
import { DialogModule } from 'primeng/dialog';
import { MultiSelectModule } from 'primeng/multiselect';
import { ContextMenuModule } from 'primeng/contextmenu';
import { SplitButtonModule } from 'primeng/splitbutton';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { InputTextModule } from 'primeng/inputtext';
import { ProgressBarModule } from 'primeng/progressbar';
import { DropdownModule } from 'primeng/dropdown';
import {fetchFieldsPipe} from './selection-tree.pipe';
import {MatMenuModule} from '@angular/material/menu';
import {MatIconModule} from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import {MatChipsModule} from '@angular/material/chips';
import { FuseSelectionTreeComponent } from './selection-tree.component';
import { MatTreeModule } from '@angular/material/tree';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { NodeDialogComponent } from './node-dialog/node-dialog';


@NgModule({
    declarations: [
        FuseSelectionTreeComponent,
        NodeDialogComponent
    ],
    imports     : [
        CommonModule,
        TableModule,
        CalendarModule,
        SliderModule,
        DialogModule,
        MultiSelectModule,
        ContextMenuModule,
        ButtonModule,
        ToastModule,
        InputTextModule,
        ProgressBarModule,
        DropdownModule,
        SplitButtonModule,
        MatIconModule,
        FormsModule,
        MatChipsModule,
        MatTreeModule,
        MatButtonModule,
        MatCheckboxModule,
        MatFormFieldModule,
        MatInputModule,
        MatIconModule,
        MatMenuModule,
    ],
    exports     : [
        FuseSelectionTreeComponent,
    ],
    providers   :[
        fetchFieldsPipe,
    ]
})
export class FuseSelectionTreeModule
{
}
